/** Traductions modal reçu dashboard (FR / AR) */
export const dashboardReceiptModalFr = {
  errNoPrintData: 'Aucune donnée à imprimer',
  errNoPrintDataDetail: 'Veuillez vous assurer que la vente contient des produits',
  errConfirm: 'Impossible de confirmer la vente',
  errConfirmDetail: 'Vérifiez le panier et réessayez.',
  successPrint: 'Impression réussie',
  successPrintDetail: 'Le reçu a été envoyé à l\'imprimante',
  errPrint: 'Erreur lors de l\'impression du reçu',
  errPrintDetail: 'Le reçu n’a pas pu être imprimé.',
  paymentCash: 'Espèces',
  paymentElectronic: 'Électronique',
  title: 'Reçu Client',
  stepsAriaLabel: 'Étapes de caisse',
  stepCart: 'Panier',
  stepPayment: 'Paiement',
  stepReceipt: 'Reçu',
  totalLabel: 'Total',
  paymentLabel: 'Paiement',
  amountPaid: 'Montant payé',
  change: 'Monnaie',
  customerOptional: 'Client (optionnel)',
  customerRequired: 'Client (obligatoire)',
  customerPlaceholder: 'Nom du client ou numéro de téléphone',
  addCustomer: '+ Ajouter "{{name}}" comme nouveau client',
  errCreditNeedsCustomer: 'Client requis pour une vente à crédit',
  errCreditNeedsCustomerDetail:
    'Sélectionnez un client existant ou créez-en un nouveau',
  printing: 'Impression...',
  print: 'Imprimer',
  confirmPrint: 'Confirmer et imprimer',
  confirmSale: 'Confirmer la vente',
  confirming: 'Confirmation...',
  cancel: 'Annuler',
  close: 'Fermer',
  paperFormatLabel: 'Format papier',
  paperFormatThermal80: 'Bon thermique 80 mm',
  paperFormatThermal58: 'Bon thermique 58 mm',
  paperFormatA5: 'A5 vertical',
  keyboardHintConfirm: 'Entrée = confirmer la vente · Retour arrière = fermer',
  keyboardHintPrint: 'Entrée = imprimer · Retour arrière = fermer',
  printAfterSaleFailed: 'Échec de l\'impression du reçu'
};

export const dashboardReceiptModalAr = {
  errNoPrintData: 'لا توجد بيانات للطباعة',
  errNoPrintDataDetail: 'يرجى التأكد من وجود منتجات في البيع',
  errConfirm: 'تعذر تأكيد البيع',
  errConfirmDetail: 'تحقق من السلة وحاول مرة أخرى.',
  successPrint: 'تم الطباعة بنجاح',
  successPrintDetail: 'تم إرسال الإيصال إلى الطابعة',
  errPrint: 'خطأ في طباعة الإيصال',
  errPrintDetail: 'تعذر طباعة الإيصال.',
  paymentCash: 'نقداً',
  paymentElectronic: 'إلكتروني',
  title: 'إيصال العميل',
  stepsAriaLabel: 'خطوات الدفع',
  stepCart: 'السلة',
  stepPayment: 'الدفع',
  stepReceipt: 'الإيصال',
  totalLabel: 'الإجمالي',
  paymentLabel: 'طريقة الدفع',
  amountPaid: 'المبلغ المدفوع',
  change: 'الباقي',
  customerOptional: 'العميل (اختياري)',
  customerRequired: 'العميل (إلزامي)',
  customerPlaceholder: 'اسم العميل أو رقم الهاتف',
  addCustomer: '+ إضافة "{{name}}" كعميل جديد',
  errCreditNeedsCustomer: 'العميل مطلوب للبيع الآجل',
  errCreditNeedsCustomerDetail: 'اختر عميلاً موجوداً أو أنشئ عميلاً جديداً',
  printing: 'جاري الطباعة...',
  print: 'طباعة',
  confirmPrint: 'تأكيد وطباعة',
  confirmSale: 'تأكيد البيع',
  confirming: 'جاري التأكيد...',
  cancel: 'إلغاء',
  close: 'إغلاق',
  paperFormatLabel: 'تنسيق الورق',
  paperFormatThermal80: 'إيصال حراري 80 مم',
  paperFormatThermal58: 'إيصال حراري 58 مم',
  paperFormatA5: 'A5 عمودي',
  keyboardHintConfirm: 'Enter = تأكيد البيع · Backspace = إغلاق',
  keyboardHintPrint: 'Enter = طباعة · Backspace = إغلاق',
  printAfterSaleFailed: 'فشلت طباعة الإيصال'
};
